module.exports = __webpack_public_path__ + "img/ry_9.99820d6e.png";